import { useContext } from 'react';
import { loggerContext } from '../provider/logger/LoggerProvider';

export default function useLogger() {
  return useContext(loggerContext);
}